"use strict";

exports.__esModule = true;
exports.default = void 0;
var _emotion = require("emotion");
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _ = require("..");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var Info = function Info(_ref) {
  var _css2;
  var direction = _ref.direction,
    children = _ref.children;
  return _react.default.createElement("article", {
    className: (0, _emotion.css)((_css2 = {
      display: 'grid',
      gridGap: 20,
      gridTemplateColumns: direction === 'row' ? 'auto 1fr' : '1fr',
      alignItems: 'center'
    }, _css2[(0, _.media)('md')] = {
      gridTemplateColumns: '1fr',
      justifyItems: 'center',
      textAlign: 'center'
    }, _css2))
  }, children);
}; // description renders title intentionally because of design inconsistencies 🤦‍

Info.Title = function (_ref2) {
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, ["children"]);
  return _react.default.createElement(_.H3, props, children);
};
Info.Description = function (_ref3) {
  var children = _ref3.children,
    props = _objectWithoutProperties(_ref3, ["children"]);
  return _react.default.createElement(_.Title, props, children);
};
Info.Image = function (props) {
  return _react.default.createElement("img", _extends({
    alt: "Info",
    width: "50px"
  }, props));
};
Info.defaultProps = {
  direction: 'row'
};
Info.propTypes = {
  direction: (0, _propTypes.oneOf)(['row', 'column']),
  children: _propTypes.node
};
Info.Title.propTypes = {
  children: _propTypes.node
};
Info.Description.propTypes = {
  children: _propTypes.node
};
var _default = Info;
exports.default = _default;